export const PAYMENT_PROVIDER = {
  /**
   * Aucun PSP : le golf n'a pas encore de contrat VADS Payline. État attendu
   * pendant la bascule progressive — il ne peut simplement pas encaisser par
   * carte. Ce n'était pas le cas avant : le défaut valait `paybox`, or Paybox
   * est retiré et tous ses appels lèvent.
   */
  NONE: 'none',
  PAYLINE: 'payline',
};

export const getPaymentProvider = (golf) => {
  if (golf?.options?.paymentProvider?.value === PAYMENT_PROVIDER.PAYLINE) {
    return PAYMENT_PROVIDER.PAYLINE;
  }
  return PAYMENT_PROVIDER.NONE;
};

export const hasPaylineContract = (golf) => {
  if (!golf?.options) return false;
  const contractOption = golf.options.paylineContractNumber;
  if (!contractOption?.value) return false;
  return typeof contractOption.value === 'string' && contractOption.value.length > 0;
};

export const isPayline = (golf) => getPaymentProvider(golf) === PAYMENT_PROVIDER.PAYLINE;

/**
 * Returns true if the golf is configured for Payline AND has a valid contract number.
 * Use this to decide whether to show the Payline payment widget.
 * Without a contract number, Payline payments are impossible.
 */
export const canUsePayline = (golf) => isPayline(golf) && hasPaylineContract(golf);
